import RecipeInfoBlock from './RecipeInfoBlock';

export default RecipeInfoBlock;
